import React from 'react'
import { applyRouterMiddleware, browserHistory, Router, createRoutes } from 'react-router'
import { Provider } from 'react-redux'
import getRoutes from './routes'
import {
  pollUploads,
  fetchCurrentUser,
  checkTranscodes,
} from './actions'
import createStore from './store'
import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie'
import { useScroll } from 'react-router-scroll'
import { setCookie, } from './misc/utilities'

Sentry.init({
  dsn: "https://e3a99ea6ec894448b4e0504a8fa294ae@o20911.ingest.sentry.io/5192543",
  release: process.env.REACT_APP_VERSION
});

window._STM_PREDATA = window._STM_PREDATA || new Proxy({}, {get: () => ''});

// We need a Root component for React Hot Loading.
function Root() {
  import('autotrack')
  .then(() => {
    window.ga('create', process.env.REACT_APP_GA_KEY, 'auto');
    window.ga('require', 'eventTracker');
    window.ga('require', 'urlChangeTracker');
    window.ga('require', 'ec');
    window.ga('send', 'pageview');
  });

  if (!Cookies.get('src_external')) {
    setCookie('src_external', document.referrer || 'DIRECT', 90000);
  }

  const store = createStore()

  Promise.all([
    store.dispatch(fetchCurrentUser()),
    new Promise((resolve) => window.onload = resolve),
  ])

  // start polling
  setInterval(() => {
    store.dispatch(pollUploads())
  }, 5000)
  setInterval(() => {
    store.dispatch(checkTranscodes())
  }, 100)

  window.addEventListener("unload", () => {
    const state = store.getState()
    navigator.sendBeacon(`${process.env.REACT_APP_API_HOST}/close`)
  });

  return (
    <Provider store={store}>
      <Router
        history={browserHistory}
        routes={createRoutes(getRoutes(store))}
        render={applyRouterMiddleware(useScroll())}
      />
    </Provider>
  )
}

export default Root
